import styled from '@emotion/styled';
import { Spin } from 'antd';

export const SadaApplicationQuestionsFormUpload = styled(Spin)``;
